import CryptoJS from 'crypto-js';
import { push } from 'connected-react-router';
import { routes } from 'settings/navigation/routes';

class Cryptography {
  private static getAppSecurityKey(): string | undefined {
    return process.env.REACT_APP_ENCRYPTION_KEY;
  }

  static encryptData(text: string): string {
    try {
      const key = Cryptography.getAppSecurityKey();
      if (!key) {
        Cryptography.handleSecurityFailure('Encryption key is missing.');
        return '';
      }
      return CryptoJS.AES.encrypt(text, key).toString();
    } catch (e) {
      console.error('Encryption failed:', e);
      Cryptography.handleSecurityFailure('Encryption failed.');
      return '';
    }
  }

  static decryptData(cipherText: string): string {
    try {
      const key = Cryptography.getAppSecurityKey();
      if (!key) {
        Cryptography.handleSecurityFailure('Decryption key is missing.');
        return '';
      }
      const bytes = CryptoJS.AES.decrypt(cipherText, key);
      const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
      if (!decryptedText) {
        throw new Error('Failed to decrypt data.');
      }
      return decryptedText;
    } catch (e) {
      console.error('Decryption failed:', e);
      Cryptography.handleSecurityFailure('Decryption failed.');
      return '';
    }
  }

  private static handleSecurityFailure(message: string): void {
    console.error(message);
    localStorageSecurityFailureCallback();
  }
}

const localStorageSecurityFailureCallback = (): void => {
  push(routes.login);
};

export default Cryptography;
